import { useState } from "react";
import { CheckCircle, XCircle, Star, ChevronRight, Monitor } from "lucide-react";
import { Button } from "@/components/ui/button";

const fastslotsScreenshot = "/img/fastslots-casino-lobby.webp";
const instantScreenshot = "/img/instant-casino-lobby.webp";
const goldenPandaScreenshot = "/img/golden-panda-casino-lobby.webp";

type ReviewData = {
  id: string;
  name: string;
  subtitle: string;
  intro: string;
  pros: string[];
  cons: string[];
  screenshot: string;
  url: string;
  categories: {
    automaty: { score: string; text: string };
    bonusy: { score: string; text: string };
    hry: { score: string; text: string };
    podpora: { score: string; text: string };
  };
  ctaText: string;
  badge?: string;
  badgeColor?: string;
  screenshotImg?: string;
};

const reviews: ReviewData[] = [
  {
    id: "fastslots",
    name: "FastSlots Casino",
    subtitle: "Nejlepší online casino real money s rychlými výplatami",
    intro: "FastSlots Casino vyniká rychlými výplatami a štědrými bonusy. Stránka funguje od roku 2024 s licencí №ALSI-1423 I 1005-FI2, vydanou Anjouan Gaming. To dělá tuto platformu atraktivní volbou pro hráče, kteří upřednostňují rychlost, spolehlivost a moderní přístup k organizaci hazardní zábavy.",
    pros: [
      "Více než 4000 her, včetně automatů, stolních her a live kasina",
      "Uvítací bonus 200 % až do 125 000 Kč + 50 volných zatočení",
      "Týdenní cashback až 10 %",
      "Podpora kryptoměn – BTC, ETH, LTC",
      "Rychlé výplaty, zpracování žádostí do 24 hodin",
    ],
    cons: [
      "Platnost bonusu – 7 dní",
      "Žádné bonusy bez vkladu",
    ],
    screenshot: "FastSlots Casino – herní lobby s výběrem automatů",
    url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM88TL4kmJ7MEGNd7ZgqdRLk/1/?pg=1",
    categories: {
      automaty: {
        score: "4.8/5",
        text: "Kasino nabízí rozsáhlou kolekci slotů od předních poskytovatelů. V katalogu hráči najdou automaty od Microgaming, Play'n GO, NetEnt aj. Najdete zde sloty na různá témata, se zajímavými mechanikami a bonusovými koly. Jsou zde také automaty s progresivními jackpoty, které dávají šanci na vysokou výhru i při minimální sázce na spin.",
      },
      bonusy: {
        score: "4.8/5",
        text: "Uvítací bonus 200 % až do 125 000 Kč a 50 volných zatočení poskytuje skvělou možnost navýšit svůj startovní herní zůstatek. Kromě toho týdenní cashback až 10 % pomáhá kompenzovat případné prohry.",
      },
      hry: {
        score: "4.7/5",
        text: "Kromě automatů má stránka široký výběr stolních her, jako je blackjack, ruleta a baccarat. Na webu je také mnoho live her s reálnými dealery, které poskytují unikátní zážitek z hraní s opravdovým krupiérem.",
      },
      podpora: {
        score: "4.9/5",
        text: "Nonstop podpora přes online chat a e-mail zajišťuje rychlou a profesionální pomoc. Hráči oceňují vysokou odbornost a vstřícnost operátorů. Odpověď v chatu nepřesahuje 3 minuty, na e-mail do 24 hodin.",
      },
    },
    ctaText: "Získejte bonus až 125 000 Kč a 50 FS v ověřeném FastSlots Casino.",
    badge: "EDITOR'S PICK",
    badgeColor: "#ff0000",
    screenshotImg: fastslotsScreenshot,
  },
  {
    id: "instant",
    name: "Instant Casino",
    subtitle: "Stránka s rychlými hrami a okamžitými výplatami výher",
    intro: "Založeno v roce 2024, Instant Casino se rychle stalo favoritem mezi českými hráči díky své hlavní přednosti – okamžitým výplatám. Rozhraní je maximálně jednoduché, důraz je kladen na pohodlí, bezpečnost a rychlost. Best casino online funguje na základě licence Komorských ostrovů №ALSI-1423 I 1005-FI2. To zaručuje legálnost provozu a ochranu zájmů hráčů.",
    pros: [
      "Okamžité výplaty bez zpoždění",
      "Více než 3 500 her od předních poskytovatelů",
      "Uvítací balíček – 200 % až do 190 000 Kč",
      "Pohodlná mobilní verze bez nutnosti stahování",
      "Přístupné hráčům z Česka i EU",
    ],
    cons: [
      "Nemá samostatnou mobilní aplikaci",
      "Uvítací bonus není bez vkladu",
      "Není lokalizováno pro Česko",
    ],
    screenshot: "Instant Casino – přehled her a uvítacího bonusu",
    url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM-u11z-n_bVh2Nd7ZgqdRLk/1/?pg=1",
    categories: {
      automaty: {
        score: "4.7/5",
        text: "V kolekci kasina je více než 2500 slotů. Hráči zde najdou vše – od klasiky po novinky s bonusovými mechanikami. Zvláště populární jsou tituly od Nolimit City, Hacksaw Gaming, Pragmatic Play a dalších. Mnoho automatů podporuje demo režim i bez registrace, což je vhodné pro začátečníky i ty, kteří chtějí hru vyzkoušet před sázením skutečných peněz.",
      },
      bonusy: {
        score: "4.6/5",
        text: "Uvítací bonus pro nováčky činí 200%, ale nemůže přesáhnout 190 000 Kč. Pro jeho získání je třeba vložit minimálně 500 Kč na první vklad a prosázet jej s požadavkem na protočení x15 během 7 dní. Na stránce jsou také každý týden k dispozici cashbacky do 10% a pořádají se turnaje pro aktivní hráče.",
      },
      hry: {
        score: "4.8/5",
        text: "Kromě slotů je k dispozici více než 200 stolních her a asi 300 live stolů. Hráči si mohou užít ruletu, blackjack, baccarat i herní show. Více než 100 rychlých a crash her posiluje image kasina jako místa s okamžitými výhrami a výplatami.",
      },
      podpora: {
        score: "4.5/5",
        text: "Podpora funguje přes chat na webu i e-mail. Odpověď je obvykle do 10–30 minut. Na platformě je také sekce FAQ s popisem nejčastějších problémů. Podpora je dostupná v angličtině a němčině, operátor však slibuje brzkou českou lokalizaci.",
      },
    },
    ctaText: "Okamžitě získáte až 190 000 Kč za registraci v Instant Casino.",
    badge: "RYCHLÉ VÝPLATY",
    badgeColor: "#7c00a5",
    screenshotImg: instantScreenshot,
  },
  {
    id: "goldenpanda",
    name: "Golden Panda",
    subtitle: "Štědré casino online s asijskou tematikou",
    intro: "Golden Panda se právem dostal do seznamu top casino online. Spuštěno v roce 2024, kasino rychle zaujalo hráče zapamatovatelným vizuálním stylem a štědrým bonusovým systémem. Kasino má licenci č. ALSI-1423 I 1005-FI2, vydanou na ostrově Anjouan. Tento dokument zajišťuje bezpečnost a férovost hry. Stránka je provedena ve stylových tmavých tónech se zlatými prvky, což vytváří atmosféru luxusu a klidu. Rozhraní je intuitivní, přechod mezi sekcemi je plynulý a rychlý.",
    pros: [
      "Тématický design se stylovou pandou",
      "Uvítací bonus 200 % až 125 000 Kč a 50 volných zatočení",
      "Více než 4000 her od 50+ poskytovatelů",
      "Rychle výplaty do 1-3 dnů",
      "Výborná optimalizace pro mobliní zařízení",
    ],
    cons: [
      "Stránka je zatím dostupná pouze v angličtině",
      "Není podpora po telefonu",
    ],
    screenshot: "Golden Panda Casino – lobby s automaty a live hrami",
    url: "https://record.discasinoaffiliates.com/_kTMXKwmZsM98YAuMxhPI-WNd7ZgqdRLk/1/?pg=1",
    categories: {
      automaty: {
        score: "4.8/5",
        text: "Hráči mají k dispozici tisíce video automatů od známých poskytovatelů jako Play'n GO, Betsoft, Pragmatic Play, Red Tiger a dalších lídrů v oboru. Na stránce je mnoho automatů s progresivními jackpoty i funkcemi nákupu bonusů. Provozovatel neustále přidává nové hry a aktualizuje tematické kolekce.",
      },
      bonusy: {
        score: "4.9/5",
        text: "Nováčky čeká poměrně štědrá uvítací nabídka – 200 % až do 125 000 Kč a 50 volných zatočení na první vklad. Pro účast v akci je třeba vložit alespoň 500 Kč. Získané peníze je nutné protočit s požadavkem na protočení x30. Pravidelní hráči mají nárok na týdenní cashback až 250 000 Kč (do 10 % z částky prohry).",
      },
      hry: {
        score: "4.7/5",
        text: "Kromě slotů je zde obrovský výběr live her, stolní klasiky i moderních okamžitých her. V kasinu je přes 250 stolů se živými dealery, včetně rulety, blackjacku, baccaratu a pokeru. Pro milovníky live zábavy jsou připraveny různé herní show v přímém přenosu.",
      },
      podpora: {
        score: "4.6/5",
        text: "Podpora je dostupná přes online chat a e-mail, operátoři odpovídají během několika minut. V bázi znalostí jsou často kladené otázky týkající se nejčastějších problémů. Jsou zde i rady pro nováčky ohledně zodpovědného hraní. Podpora je zatím dostupná pouze v angličtině, ale pracuje se na zavedení dalších jazyků. Do budoucna se plánuje spuštění podpory přes Telegram.",
      },
    },
    ctaText: "Zaregistrujte se v Golden Panda a získejte až 125 000 Kč a 50 volných zatočení pro první sázky.",
    badge: "NEJVĚTŠÍ BONUS",
    badgeColor: "#1a7a00",
    screenshotImg: goldenPandaScreenshot,
  },
];

function ScoreBadge({ score }: { score: string }) {
  return (
    <span className="inline-flex items-center gap-1 text-xs font-bold text-[#003da5] bg-[#003da5]/8 px-2 py-0.5 rounded-full">
      <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
      {score}
    </span>
  );
}

function ScreenshotPlaceholder({ label, src }: { label: string; src?: string }) {
  const [failed, setFailed] = useState(false);
  if (src && !failed) {
    return (
      <div className="rounded-xl overflow-hidden border border-gray-100" style={{ aspectRatio: "16/9" }}>
        <img
          src={src}
          alt={label}
          className="w-full h-full object-cover object-top"
          width="900"
          height="500"
          onError={() => setFailed(true)}
        />
      </div>
    );
  }
  return (
    <div
      className="rounded-xl flex flex-col items-center justify-center gap-2 border border-gray-100"
      style={{ aspectRatio: "16/9", background: "linear-gradient(135deg, #f0f5ff 0%, #e8f0fe 100%)" }}
    >
      <Monitor className="w-8 h-8 text-[#003da5]/25" />
      <span className="text-gray-400 text-xs font-medium">{label}</span>
    </div>
  );
}

function ReviewCard({ review }: { review: ReviewData }) {
  const [activeTab, setActiveTab] = useState<keyof ReviewData["categories"]>("automaty");
  const tabs: (keyof ReviewData["categories"])[] = ["automaty", "bonusy", "hry", "podpora"];

  return (
    <div
      id={review.id}
      className="rounded-2xl border border-[#003da5]/35 bg-white overflow-hidden"
      data-testid={`review-card-${review.id}`}
    >
      <div
        className="px-6 py-8 sm:px-8"
        style={{ background: "linear-gradient(135deg, #001a4d 0%, #003da5 100%)" }}
      >
        <div className="flex flex-wrap items-center gap-2 mb-3">
          {review.badge && (
            <span
              className="text-white text-xs font-bold px-3 py-1 rounded-full"
              style={{ background: review.badgeColor }}
            >
              {review.badge}
            </span>
          )}
        </div>
        <h3 className="text-2xl font-black text-white mb-1">{review.name}</h3>
        <p className="text-white/60 text-sm font-medium mb-3">{review.subtitle}</p>
        <p className="text-white/70 text-sm leading-relaxed max-w-2xl">{review.intro}</p>
        <div className="mt-5">
          <a href={review.url} target="_blank" rel="sponsored noopener noreferrer">
            <Button
              className="hraj-btn font-bold gap-2"
              style={{ background: "#ff0000" }}
              data-testid={`button-review-cta-${review.id}`}
            >
              Hraj
              <ChevronRight className="hraj-arrow w-4 h-4" />
            </Button>
          </a>
        </div>
      </div>

      <div className="p-6 sm:p-8">
        <div className="grid sm:grid-cols-2 gap-8 mb-6">
          <div>
            <h4 className="text-green-700 font-bold text-sm uppercase tracking-wide mb-3 flex items-center gap-1">
              <CheckCircle className="w-4 h-4" /> Výhody
            </h4>
            <ul className="flex flex-col gap-2">
              {review.pros.map((p) => (
                <li key={p} className="flex items-start gap-2 text-sm text-gray-700">
                  <CheckCircle className="w-3.5 h-3.5 text-green-500 flex-shrink-0 mt-0.5" />
                  {p}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-red-600 font-bold text-sm uppercase tracking-wide mb-3 flex items-center gap-1">
              <XCircle className="w-4 h-4" /> Nevýhody
            </h4>
            <ul className="flex flex-col gap-2">
              {review.cons.map((c) => (
                <li key={c} className="flex items-start gap-2 text-sm text-gray-700">
                  <XCircle className="w-3.5 h-3.5 text-red-400 flex-shrink-0 mt-0.5" />
                  {c}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mb-6">
          <ScreenshotPlaceholder label={review.screenshot} src={review.screenshotImg} />
        </div>

        <div>
          <div className="flex gap-1 border-b border-gray-100 mb-5">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 text-sm font-semibold capitalize transition-colors border-b-2 -mb-px ${
                  activeTab === tab
                    ? "border-[#003da5] text-[#003da5]"
                    : "border-transparent text-gray-500 hover:text-gray-800"
                }`}
                data-testid={`tab-${review.id}-${tab}`}
              >
                {tab === "automaty" ? "Herní automaty" : tab === "bonusy" ? "Bonusové nabídky" : tab === "hry" ? "Kasino hry" : "Zákaznická podpora"}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2 mb-3">
            <span className="font-bold text-gray-900 text-sm capitalize">
              {activeTab === "automaty" ? "Herní automaty" : activeTab === "bonusy" ? "Bonusové nabídky" : activeTab === "hry" ? "Kasino hry" : "Zákaznická podpora"}:
            </span>
            <ScoreBadge score={review.categories[activeTab].score} />
          </div>
          <p className="text-gray-700 text-sm leading-relaxed mb-4">
            {review.categories[activeTab].text}
          </p>

          {activeTab === "bonusy" && (
            <div
              className="p-4 rounded-xl border border-[#003da5]/15"
              style={{ background: "linear-gradient(135deg, #f0f5ff 0%, #e8f0fe 100%)" }}
            >
              <p className="text-[#003da5] font-semibold text-sm">{review.ctaText}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export function FeaturedReviews() {
  return (
    <section id="recenze" className="py-16 bg-white" data-testid="section-reviews">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
        <div className="mb-10">
          <h2 className="text-3xl font-black text-gray-900 mb-3">
            Podrobnější pohled na našich 3 nejlepších doporučení pro real money casino
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Pečlivě jsme vybrali tři top online casino, která nabízejí skvělé bonusy, rozmanité hry a spolehlivou podporu pro české hráče:
          </p>
          <ul className="mt-2 flex gap-4 flex-wrap">
            {["FastSlots Casino", "Instant Casino", "Golden Panda"].map((name) => (
              <li key={name} className="text-[#003da5] font-semibold text-sm">• {name}</li>
            ))}
          </ul>
          <p className="text-gray-600 text-sm mt-3 leading-relaxed">
            Každé z nich bylo prověřeno z hlediska bezpečnosti, uživatelské přívětivosti a kvality služeb. V mini-recenzi níže najdete klíčové informace o kasinu: rok založení, hlavní výhody, bonusy, výběr her, mobilní funkce a další vlastnosti.
          </p>
        </div>

        <div className="flex flex-col gap-8">
          {reviews.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>
      </div>
    </section>
  );
}
